module.exports = __webpack_public_path__ + "img/representantes-farmaceuticos-digitais-o-futuro-da-industria-baixe-o-ebook.73dd2641.webp";